import {createBrowserRouter, Navigate, RouterProvider} from 'react-router-dom';
import * as React from 'react';
import {observer} from 'mobx-react';

import Home from "./functionalities/home/HomeScreen";
import {AppLayout} from "./components/AppLayout";
import {
    CART_PATH,
    CHECKING_ACCOUNT_PATH,
    HOME_PATH,
    ID_PRODUCT_DETAIL_PATH,
    ID_PRODUCTS_LINE_PATH,
    LOGIN_PATH,
    LOGOUT_PATH,
    ORDER_DETAIL_PATH,
    TICKETS_PATH,
    SEARCH_ARTICLES_PATH,
    ORDERS_HISTORY_PATH,
    ORDERS_PATH,
    PASSWORD_RESET_PATH,
    PRODUCT_PATH,
    PRODUCTS_CATEGORIES_PATH,
    PRODUCTS_LINE_PATH,
    PRODUCTS_PATH,
    PROFILE_PATH, SEARCH_PATH,
} from "./routes";
import OrdersManagementScreen from "./functionalities/orders/ticketsManagement/OrderTicketsManagementScreen";
import CheckingAccountScreen from "./functionalities/checking_account/CheckingAccountScreen";
import LoginScreen from "./functionalities/login/LoginScreen";
import RecoverPasswordScreen from "./functionalities/recover_password/RecoverPasswordScreen";
import ProfileScreen from "./functionalities/profile/ProfileScreen";
import CartCheckoutScreen from "./functionalities/cart_checkout/CartCheckoutScreen";
import ProductsLineScreen from "./functionalities/products/line/ProductsLineScreen";
import ProductsCategoryScreen from "./functionalities/products/category/ProductsCategoryScreen";
import ProductDetailScreen from "./functionalities/products/detail/ProductDetailScreen";
import OrdersHistoryScreen from "./functionalities/orders/history/OrdersHistoryScreen";
import {useApplication} from "./ApplicationProvider";
import OrderDetailScreen from "./functionalities/orders/detail/OrderDetailScreen";
import MarketplaceSearchScreen from "./functionalities/products/search/MarketplaceSearchScreen";
import LogoutScreen from "./functionalities/logout/LogoutScreen";

function AppRouter() {
    const application = useApplication();
    const lastPathResourceFor = (path) => {
        return path.split('/').pop()
    }

    function userAllowedRoutes() {
        if (!application.session() || !application.session().active()) {
            return [
                {
                    path: LOGIN_PATH,
                    element: <LoginScreen/>,
                },
                {
                    path: PASSWORD_RESET_PATH,
                    element: <RecoverPasswordScreen/>,
                },
                {
                    path: LOGOUT_PATH,
                    element: <LogoutScreen/>,
                },
                {
                    path: '*',
                    element: <Navigate to={LOGIN_PATH}/>,
                },
            ]
        }

        function allRoutes() {
            let routes = [...allowedToAllRoutes()];
            routes.push(...allowedToOperationalRole());
            routes.push(...allowedToAdministrativeRole());

            return routes
        }

        function allowedToAllRoutes() {
            return [
                {
                    path: LOGIN_PATH,
                    element: <Navigate to={HOME_PATH}/>,
                },
                {
                    path: LOGOUT_PATH,
                    element: <LogoutScreen/>,
                },
                {
                    path: HOME_PATH,
                    element: <AppLayout/>,
                    children: [
                        {
                            path: lastPathResourceFor(HOME_PATH),
                            element: <Home/>,
                        },
                        {
                            path: TICKETS_PATH,
                            element: <OrdersManagementScreen section="Solicitudes"/>,
                        },
                    ]
                },
                {
                    path: PROFILE_PATH,
                    element: <AppLayout/>,
                    children: [
                        {
                            path: lastPathResourceFor(PROFILE_PATH),
                            element: <ProfileScreen/>,
                        },
                    ]
                },
                {
                    path: PRODUCTS_PATH,
                    element: <AppLayout/>,
                    children: [
                        {
                            path: lastPathResourceFor(PRODUCTS_CATEGORIES_PATH),
                            element: <ProductsCategoryScreen/>,
                        }
                    ]
                },
                {
                    path: PRODUCT_PATH,
                    element: <AppLayout/>,
                    children: [
                        {
                            path: ID_PRODUCT_DETAIL_PATH,
                            element: <ProductDetailScreen/>,
                        },
                    ]
                },
                {
                    path: PRODUCTS_LINE_PATH,
                    element: <AppLayout/>,
                    children: [
                        {
                            path: ID_PRODUCTS_LINE_PATH,
                            element: <ProductsLineScreen/>,
                        },
                    ]
                },
                {
                    path: SEARCH_PATH,
                    element: <AppLayout/>,
                    children: [
                        {
                            path: lastPathResourceFor(SEARCH_ARTICLES_PATH),
                            element: <MarketplaceSearchScreen/>,
                        },
                    ]
                },
            ];
        }

        function allowedToOperationalRole() {
            return [
                {
                    path: HOME_PATH,
                    element: <AppLayout/>,
                    children: [
                        {
                            path: lastPathResourceFor(CART_PATH),
                            element: <CartCheckoutScreen/>,
                        },
                    ]
                },
                {
                    path: ORDERS_PATH,
                    element: <AppLayout/>,
                    children: [
                        {
                            path: lastPathResourceFor(ORDERS_HISTORY_PATH),
                            element: <OrdersHistoryScreen/>,
                        },
                        {
                            path: ORDER_DETAIL_PATH,
                            element: <OrderDetailScreen/>,
                        },
                    ]
                },
            ];
        }


        function allowedToAdministrativeRole() {
            return [
                {
                    path: HOME_PATH,
                    element: <AppLayout/>,
                    children: [
                        {
                            path: lastPathResourceFor(CHECKING_ACCOUNT_PATH),
                            element: <CheckingAccountScreen/>,
                        },
                    ]
                },
            ];
        }

        const business = application.business();
        const userRoles = application.session().user().roles;

        if (userRoles.includes(business.marketplace_general_administrator_role())) {
            return allRoutes();
        }

        let allowedRoutes = [... allowedToAllRoutes()]
        if (userRoles.includes(business.marketplace_operational_role())) {
            allowedRoutes.push(... allowedToOperationalRole())
        }
        if (userRoles.includes(business.marketplace_administrative_role())) {
            allowedRoutes.push(... allowedToAdministrativeRole())
        }

        return allowedRoutes
    }

    return <RouterProvider router={createBrowserRouter(userAllowedRoutes())}/>
}

export default observer(AppRouter);